export type DatePeriodProps = {
  formattedPeriod: JSX.Element;
};

const DatePeriodComponent = function ({ formattedPeriod }: DatePeriodProps): JSX.Element {
  return formattedPeriod;
};

export default DatePeriodComponent;
